export default __webpack_public_path__ + "static/media/Freebooter's Legguards of Crouching Calm.93eb7398.jpg";